// removed by extract-text-webpack-plugin
module.exports = {"container":"_2ZjDZdtIWB_19oVCxQi-CS","infoContainer":"_10CsF_8EumvsBhG0eIkK8e","intersectionContainer":"_2bDavyZeUPrs5Akyep9x_V"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupPage/GroupPage.pcss
// module id = 1415
// module chunks = 0